import {extractDocs} from '~/utils/transform-payload'

export function useTechnologies() {
  const sdk = usePayloadSdk()
  const route = useRoute()

  const fetch = async () => {
    const response = await sdk.find({
      collection: 'technologies',
      limit: 100,
      where: {
        _status: {equals: 'published'},
      },
    })

    const technologies = extractDocs(response)
    return technologies
  }

  const fetchBySlug = async (slug: string) => {
    const response = await sdk.find({
      collection: 'technologies',
      depth: 1, // Populates image relationship
      where: {
        slug: {equals: slug},
      },
      draft: route.query.preview === 'yes',
      limit: 1,
    })

    const technologies = extractDocs(response)
    return technologies[0] || null
  }

  return {
    fetch,
    fetchBySlug,
  }
}
